/** Implements keyboard navigation for task lists. */
// @ts-check
import { useEffect, useRef } from 'react';
import { useAuth } from '@/features/auth/useAuth';
import useTaskStructure from '@/features/tasks/hooks/mutations/use-task-structure';
import { safeGenerateKeyBetween } from '@/features/tasks/utils/interactions/listKeyHelpers';
import { processKeyDown } from '@/features/tasks/utils/interactions/listKeyboardNavUtils';

const useTaskListKeyboardNavigation = (props) => {
  const { filteredTasks, setSelectedIndex } = props;
  const { user } = useAuth();
  const { moveTask } = useTaskStructure();

  const previousSelectedIndexRef = useRef(-1);
  const selectedTaskIdBeforeReorder = useRef(null);
  const stateRef = useRef(props);
  stateRef.current = {
    ...props,
    onMove: (taskId, pos) => {
      const orderKey = safeGenerateKeyBetween(pos.previousKey, pos.nextKey);
      moveTask(taskId, { orderKey }, user.uid);
    },
  };

  useEffect(() => {
    const handleKeyDown = (e) =>
      processKeyDown(
        e,
        stateRef,
        moveTask,
        user,
        previousSelectedIndexRef,
        selectedTaskIdBeforeReorder,
      );
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [moveTask, user]);

  useEffect(() => {
    const id = selectedTaskIdBeforeReorder.current;
    if (id) {
      const task = filteredTasks.find((t) => t.id === id);
      if (task) {
        setSelectedIndex(task.id);
        selectedTaskIdBeforeReorder.current = null;
      }
    }
  }, [filteredTasks, setSelectedIndex]);

  return { previousSelectedIndexRef };
};

export default useTaskListKeyboardNavigation;
